import type { DomainPublic } from '@creator/sdk/modules/domain/domain.model';
import creatorSdk from '@src/services/creator-sdk';

export async function loadPublicData(id: string): Promise<DomainPublic | undefined> {
    return creatorSdk.domainModule.getPublicData(id);
}
